/**
 * Validation config for spanish regulations
 */

define(function(require, exports, module) {
    'use strict';

    const userValidationConfig = require('modules/user/user.validation.config');
    const validationUtil = require('modules/user/spanish-regulations/user.validation.util');
    const _ = require('underscore');
    const i18n = require('i18n');

    const { getSpanishNameValidationConfig, checkDNI, checkNIE } = validationUtil;

    module.exports = function() {
        var config = userValidationConfig();

        return _.extend({}, config, {
            personalId: {
                fn: {
                    fn: function($inputs, cfg, form, dfd, event, data) {
                        var $formContainer = form.$el.parents('.fn-register-content');
                        var citizenship, country, personalId;

                        data = data || {};

                        citizenship = data.citizenship || form.data('citizenship');
                        country = data.country || $formContainer.find('.fn-country')[0].value;
                        personalId = $inputs[0].value || '';

                        if (country !== 'ES' &&
                            (citizenship !== 'ES' || citizenship === 'ES' && personalId === '')) {
                            return true;
                        } else if (personalId.length > 9) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.personalIdLong');
                            return false;
                        } else if (personalId.length < 8) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.personalIdShort');
                            return false;
                        }

                        this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.personalIdInvalid');
                        return citizenship === 'ES' ?
                            checkDNI(personalId) : country === 'ES' ? checkNIE(personalId) : true;
                    },
                    message: i18n.t('playtech.mobile.system.user.tooltip.spanish.personalIdInvalid')
                }
            },
            firstName: getSpanishNameValidationConfig(
                'playtech.mobile.system.user.tooltip.spanish.nameShort',
                'playtech.mobile.system.user.tooltip.spanish.nameLong',
                'playtech.mobile.system.user.tooltip.spanish.nameRequired'
            ),
            firstSurname: getSpanishNameValidationConfig(
                'playtech.mobile.system.user.tooltip.spanish.firstSurnameShort',
                'playtech.mobile.system.user.tooltip.spanish.firstSurnameLong',
                'playtech.mobile.system.user.tooltip.spanish.firstSurnameRequired'
            ),
            secondSurname: {
                fn: {
                    fn: function($inputs, cfg, form) {
                        var citizenship = form.data('citizenship'),
                            lastSurnameValue = $inputs[0].value || '';

                        if (lastSurnameValue.length > 40) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.secondSurnameLong');
                            return false;
                        } else if (lastSurnameValue && !/^[A-Za-züõöÖÄß,\.\'\s\-]+$/.test(lastSurnameValue)) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.firstname.regexp');
                            return false;
                        } else if (citizenship !== 'ES') {
                            return true; // not required for non-spanish, but must still be valid if entered
                        } else if (!lastSurnameValue) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.secondSurnameRequired');
                            return false;
                        } else if (lastSurnameValue.length < 2) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.secondSurnameShort');
                            return false;
                        }

                        return true;
                    },
                    message: i18n.t('playtech.mobile.system.user.tooltip.spanish.firstSurnameRequired')
                }
            },
            passwordSpanish: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.required')
                },
                length: {
                    min: 5,
                    max: 10,
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.length')
                },
                fn: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.required'),
                    fn: function($inputs, cfg, form) {
                        var $formContainer = form.$el.parents('.fn-register-content'),
                            password = $inputs[0].value,
                            userName = form.data('userName') || '',
                            day = $formContainer.find('#day')[0].value,
                            month = $formContainer.find('#month')[0].value,
                            year = $formContainer.find('#year')[0].value,
                            firstName = $formContainer.find('.fn-full-first-name')[0].value,
                            lastName = $formContainer.find('.fn-full-first-surname')[0].value,
                            secondLastName = $formContainer.find('.fn-full-second-surname')[0].value,
                            forbidden = [
                                day + month,
                                day + month + year,
                                day + month + year.substr(2, 4),
                                userName.toLowerCase(),
                                firstName.toLowerCase(),
                                lastName.toLowerCase(),
                                secondLastName.toLowerCase()
                            ].filter(function(entry) { return entry; });

                        if (!/^[A-Za-z0-9.@_#$'&+()*`;!?,-\/]+$/.test($inputs.val())) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.password.regexp');
                            return false;
                        } else if (forbidden.filter(function(forbiddenEntry) {
                                return password.toLowerCase().includes(forbiddenEntry);
                            }).length > 0) {

                            this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.passwordContainsData');
                            return false;
                        }

                        return true;
                    }
                }
            },
            identityDocument: {
                fn: {
                    message: i18n.t('playtech.mobile.system.tooltip.required'),
                    fn: function($inputs, cfg, form) {
                        var $formContainer = form.$el.parents('.fn-register-content');
                        var documentType = form.data('documentType');
                        var country = $formContainer.find('.fn-country')[0].value;
                        var value = $inputs[0].value;

                        if (country !== 'ES' && documentType === $inputs.attr('id')) {
                            return Boolean(value);
                        }

                        return true;
                    }
                }
            },
            taxResidence: {
                fn: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.spanish.taxResidence'),
                    fn: function($inputs, cfg, form) {
                            return form.data('countrycode') === 'ES' ? Boolean($inputs[0].value) : true;
                    }
                }
            }
        });
    };
});
